<div class="education-level dropdown">
  <div class="education-institution">
    <span class="input-header">{{ 'label.EducationLevel' | translate }}</span>
    <div>
      <p-multiSelect
        [options]="educationLevelList"
        (onChange)="onSelectEducationLevels($event)"
        optionLabel="text"
        [virtualScroll]="false"
        [virtualScrollItemSize]="50"
        [showToggleAll]="false"
        [appendTo]="'body'"
        [(ngModel)]="educationLevel"
        [style]="{ width: '380px', height: '38px', border: '1px solid #DDD' }"
      >
      </p-multiSelect>
    </div>
  </div>

  <div class="education-institution">
    <span class="input-header">{{ 'label.University' | translate }}</span>
    <div>
      <p-multiSelect
        [options]="educationalInstitutionList"
        (onChange)="onSelectInstitutions($event)"
        optionLabel="name"
        [virtualScroll]="false"
        [virtualScrollItemSize]="50"
        [showToggleAll]="false"
        [appendTo]="'body'"
        [(ngModel)]="institutions"
        [style]="{ width: '380px', height: '38px', border: '1px solid #DDD' }"
      >
      </p-multiSelect>
    </div>
  </div>

  <div class="program-dropdown">
    <span class="input-header">{{ 'label.Program' | translate }}</span>
    <div>
      <p-multiSelect
        [options]="educationalProgramList"
        (onChange)="onSelectPrograms($event)"
        optionLabel="name"
        [virtualScroll]="false"
        [virtualScrollItemSize]="50"
        [showToggleAll]="false"
        [appendTo]="'body'"
        [(ngModel)]="programs"
        [style]="{ width: '380px', height: '38px', border: '1px solid #DDD' }"
      >
      </p-multiSelect>
    </div>
  </div>
</div>
